import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { validateConfig } from '@/config'
import { logger } from '@/utils/logger'
import { setupMockAPI } from '@/services/mock-api'
import { config } from '@/config/environment'

// Validate configuration on startup
if (!validateConfig()) {
  logger.error('Configuration validation failed - check environment variables')
}

// Setup mock API if needed
if (config.mockMode) {
  setupMockAPI();
}

// Log application startup
logger.info('Application starting', {
  timestamp: new Date().toISOString(),
  userAgent: navigator.userAgent,
  mockMode: config.mockMode
})

createRoot(document.getElementById("root")!).render(<App />);
